import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
  Outlet
} from 'react-router-dom';
import { MotionConfig } from 'framer-motion';
import { Provider as ReduxProvider } from 'react-redux';
import { SWRConfig } from 'swr';

// Context Providers
import { Provider as ChannelProvider } from './contexts/Channel';
import { Provider as LastFocusedElementProvider } from './contexts/LastFocusedElement';
import { Provider as ModalProvider } from './contexts/Modal';
import { Provider as NotificationProvider } from './contexts/Notification';
import { Provider as ResponsiveDeviceProvider } from './contexts/ResponsiveDevice';
import { Provider as TooltipsProvider } from './contexts/Tooltips';
import { Provider as UserProvider } from './contexts/User';
import { Provider as ThemeProvider } from './contexts/Theme';
import { Provider as AppSyncPRovider } from './contexts/Appsync/Appsync';

// Pages
import { ChannelDirectory, UserManagement } from './pages';

// Components
import ErrorBoundary from './components/ErrorBoundary';
import PageUnavailable from './components/PageUnavailable';

// Other imports
import store from './store';
import { AppLayoutWithNavbar, RequireAuth } from './layouts';
import { SigninUser } from './pages/UserManagement/subpages';
import { stateCleanupLoader } from './loaders';

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route
      element={
        <ReduxProvider store={store}>
          <ErrorBoundary>
            <MotionConfig reducedMotion="user">
              <LastFocusedElementProvider>
                <ThemeProvider>
                  <ResponsiveDeviceProvider>
                    <NotificationProvider>
                      <ModalProvider>
                        <TooltipsProvider>
                          <UserProvider>
                            <SWRConfig value={{}}>
                              <Outlet />
                            </SWRConfig>
                          </UserProvider>
                        </TooltipsProvider>
                      </ModalProvider>
                    </NotificationProvider>
                  </ResponsiveDeviceProvider>
                </ThemeProvider>
              </LastFocusedElementProvider>
            </MotionConfig>
          </ErrorBoundary>
        </ReduxProvider>
      }
    >
      <Route element={<RequireAuth />}>
        <Route
          element={
            <AppSyncPRovider>
              <ChannelProvider>
                <AppLayoutWithNavbar />
              </ChannelProvider>
            </AppSyncPRovider>
          }
        >
          <Route
            index
            element={<ChannelDirectory />}
            loader={stateCleanupLoader}
          />
          <Route path="*" element={<PageUnavailable />} />
        </Route>
      </Route>

      {/* PUBLIC PAGES - User Management */}
      <Route element={<UserManagement />} loader={stateCleanupLoader}>
        <Route path="login" element={<SigninUser />} />
      </Route>
    </Route>
  )
);

const App = () => <RouterProvider router={router} />;

export default App;
